import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { insertTrackEvent } from '@comeon/analytics';

import { showSupportDialogBox } from '~/components/support/ducks';
import useTranslations from '~/components/translation/use-translations';

const StyledButtonContent = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
`;

const textKeys = ['SUPPORT_LOADING_SUPPORT'];

const ContactAdaAgent = ({
	buttonIcon,
	buttonText = 'MOBILE_MAIN_MENU_SUPPORT',
	callbackFunction,
	className,
	dataAt = 'ada-support-button',
	metaFields,
	proactiveChatReason
}) => {
	const dispatch = useDispatch();
	const supportLoading = useSelector(state => state.support.supportLoading);

	useEffect(() => {
		return () => {
			window.adaEmbed?.setMetaFields({
				proactiveChatReason: ''
			});
		};
	}, []);

	const { isLoadingTranslations, translations: t } = useTranslations([...textKeys, buttonText]);

	const clickHandler = useCallback(() => {
		const { gtmCategory, ...restMetaFields } = metaFields;

		dispatch(
			showSupportDialogBox(true, () => {
				window.adaEmbed?.setMetaFields({
					proactiveChatReason:
						proactiveChatReason?.length > 1 ? proactiveChatReason.join(' ') : proactiveChatReason[0],
					...restMetaFields
				});
			})
		);

		// Adding the GTM event
		if (gtmCategory) {
			insertTrackEvent({
				category: gtmCategory,
				action: 'Failed',
				label: `Click - ${t[buttonText]}`
			});
		}

		// Call the callback function if it exists
		if (callbackFunction) {
			callbackFunction();
		}
	}, [metaFields, dispatch, callbackFunction, proactiveChatReason, t, buttonText]);

	if (isLoadingTranslations) return null;

	if (supportLoading) {
		return (
			<button className={`u-relative btn ${className ?? 'btn--secondary'} u-divider-5`} disabled>
				<span>{t.SUPPORT_LOADING_SUPPORT}</span>
				<div className="spinner" />
			</button>
		);
	}

	return (
		<button
			className={`u-relative btn ${className ?? 'btn--secondary'}`}
			data-at={dataAt}
			type="button"
			onClick={clickHandler}
		>
			<StyledButtonContent className="verify-mail-support-btn">
				{buttonIcon || ''}
				<span>{t[buttonText]}</span>
			</StyledButtonContent>
		</button>
	);
};

export default ContactAdaAgent;
